import { lazy } from "react";
import { RouterItemType } from "@/app/index";

const LayoutPageAccounts = lazy(() => import("./layout/index"));

export const routerPageAccounts: RouterItemType = {
  path: "/accounts",
  authorize: true,
  element: <LayoutPageAccounts />,
};
